import React, { Component } from 'react';

class Column extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false, height: 0, width: 0 };
  }

  componentDidMount() {
    this.updatePredicate();
    window.addEventListener('resize', this.updatePredicate);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePredicate);
  }

  updatePredicate = () => {
    this.setState({
      width: window.innerWidth
    });
    if (window.innerWidth > 991) {
      this.setState({ height: 'auto', isExpanded: true });
    } else {
      this.setState({ height: 0, isExpanded: false });
    }
    console.log(this.state.height);
  };

  toggle = e => {
    e.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded,
      height: this.refs.inner.clientHeight
    });
  };
  render() {
    const { title, children } = this.props;
    const { isExpanded, height } = this.state;
    const currentHeight = isExpanded ? height : 0;
    return (
      <div className="footer__container__column">
        <div className="footer__container__column__headerContainer">
          <h3 className="footer__container__column__headerContainer__header">
            {title}
          </h3>
          <i
            onClick={e => this.toggle(e)}
            className={this.state.isExpanded ? 'fas fa-minus' : 'fas fa-plus'}
          />
        </div>
        <div
          className="footer__container__column__wrapper"
          style={{ height: currentHeight }}
        >
          <div
            className="footer__container__column__wrapper__contentContainer"
            ref="inner"
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default Column;



// WEBPACK FOOTER //
// ./src/components/Footer/Column/Column.js